module.exports = __webpack_public_path__ + "img/refresh.abe3c2f0.svg";